/**
 * Stub para @boosting/integrations
 * 
 * Este package contiene código solo para Node.js (cheerio, firebase-admin, etc.)
 * En el frontend, estos servicios deben llamarse via Cloud Functions.
 * 
 * Este stub exporta tipos y funciones mock para evitar errores de importación.
 */

const notAvailable = (name: string) => () => {
  console.warn(`⚠️ ${name} no está disponible en el navegador. Usa Cloud Functions.`);
  return null;
};

// === Google Trends ===
export const createGoogleTrendsService = notAvailable('GoogleTrendsService');
export type GoogleTrendsService = any;
export const DEFAULT_TIMEZONE = 'Europe/Madrid';
export type TrendingTopic = any;
export type RelatedQuery = any;
export type InterestOverTime = any;
export type TrendsSearchHistory = any;

// === Google Ads ===
export const createGoogleAdsService = notAvailable('GoogleAdsService');
export type GoogleAdsService = any;
export type GoogleAdsConfig = any;
export type GoogleAdsCampaign = any;
export type GoogleAdsKeyword = any;
export type GoogleAdsMetrics = any;

// === Email ===
export const createEmailService = notAvailable('EmailService');
export type EmailService = any;
export type EmailMessage = any;
export type SendEmailOptions = any;
export type SendResult = any;
export const DEFAULT_TEMPLATES = {};
export const EMAIL_PROVIDERS = {};
export type EmailProvider = any;
export type EmailStats = any;
export type EmailConfig = any;

// === PhantomBuster ===
export const createPhantomBusterService = notAvailable('PhantomBusterService');
export type PhantomBusterService = any;
export const PHANTOM_AGENTS = {};
export const LINKEDIN_LIMITS = { dailyConnectionRequests: 100, dailyMessages: 100 };
export const LINKEDIN_SAFETY_LIMITS = { dailyConnectionRequests: 50, dailyMessages: 50 };
export type LinkedInProfile = any;
export type LinkedInConnectionRequest = any;
export type ProspectionCampaign = any;
export type GlobalProspectionStats = any;
export type CampaignStatus = any;
export type Prospect = any;
export type ProspectStatus = any;
export type MessageSequence = any;
export type SequenceStep = any;
export type PhantomAgent = any;
export type ProxyConfig = any;
export type WorkingHours = any;
export type WarmupStatus = any;
export type CustomLimits = any;
export type DailyStats = any;
export type WeeklyStats = any;

// === Scraping ===
export const getURLResolver = notAvailable('URLResolver');
export const getContentScraper = notAvailable('ContentScraper');
export type ScrapingResult = any;
export type ScrapingConfig = any;
export type ScraperType = any;
export type UniversalScrapingResult = any;
export const createUniversalScraper = notAvailable('UniversalScraper');

// === Analytics ===
export const createAnalyticsService = notAvailable('AnalyticsService');
export const createGoogleAnalytics = notAvailable('GoogleAnalytics');
export const createFirebaseAnalytics = notAvailable('FirebaseAnalytics');
export type AnalyticsService = any;
export type AnalyticsEvent = any;
export type UserProperties = any;
export type ConsentSettings = any;
export type AnalyticsConfig = any;

// === YouTube ===
export const createYouTubeService = notAvailable('YouTubeService');
export type YouTubeVideoMetadata = any;

// Default export
export default {
  createGoogleTrendsService,
  createGoogleAdsService,
  createEmailService,
  createPhantomBusterService,
  getURLResolver,
  getContentScraper,
  createAnalyticsService,
  createGoogleAnalytics,
  createFirebaseAnalytics,
  createYouTubeService,
  PHANTOM_AGENTS,
  LINKEDIN_LIMITS,
  LINKEDIN_SAFETY_LIMITS,
  DEFAULT_TEMPLATES,
  EMAIL_PROVIDERS,
  DEFAULT_TIMEZONE,
};
